import React, { Component } from 'react'
import { Table } from 'react-bootstrap'

class Lidmaatschappen extends Component {
    constructor(props) {
        super(props)
        this.getMemberships = this.getMemberships.bind(this)
        this.getTotalPoints = this.getTotalPoints.bind(this)
    }

    getMemberships() {
        let data = this.props.data
        return data && data.length > 0 ? data.map((m, index) => {
            return <tr key={index}>
                <td>{m.institution}</td>
                <td>{m.function}</td>
                <td>{m.fromYear}</td>
                <td>{m.finishYear}</td>
                <td>{m.points}</td>
            </tr>
        }) : null
    }

    getTotalPoints() {
        let data = this.props.data
        return data && data.length > 0 ?
            <tr>
                <td colSpan='4'><strong>Totaal ke´s</strong></td>
                <td><strong>{data.map(t => { return t.points }).reduce((acc, val) => acc + val)}</strong></td>
            </tr> : null
    }

    render() {
        return (
            <div className="rapport">
                <h5><strong>{this.props.permanent ? "Permanente lidmaatschappen" : "Lidmaatschappen"}</strong></h5>
                <Table responsive bordered className="lidmaatschappen">
                    <thead>
                        <tr>
                            <th>vereniging</th>
                            <th>functie</th>
                            <th>van jaar</th>
                            <th>t/m jaar</th>
                            <th>Ke's</th>
                        </tr>
                    </thead>

                    <tbody>
                        {this.getMemberships()}
                        {this.getTotalPoints()}
                    </tbody>
                </Table>
            </div>)

    }
}

export default Lidmaatschappen;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Rapport/Lidmaatschappen.js